import { type MutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from 'shared/hooks/utils';

const URL = 'accounting_details/excluded_daybooks';

export type UpdateExcludedDaybooksVariables = ReadonlyArray<string>;

export async function updateExcludedDaybooks(
  axiosInstance: Promise<AxiosInstance>,
  daybooks: UpdateExcludedDaybooksVariables,
): Promise<ApiResponse> {
  const instance = await axiosInstance;

  return instance.put(URL, daybooks);
}

export function useUpdateExcludedDaybooks(
  options: MutationOptions<ApiResponse, ApiError, UpdateExcludedDaybooksVariables> = {},
) {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, UpdateExcludedDaybooksVariables>({
    mutationFn: daybooks => updateExcludedDaybooks(axiosInstance, daybooks),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['company-configuration'] });
    },
    ...options,
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    UpdateExcludedDaybooksVariables,
    'updateExcludedDaybooks'
  >('updateExcludedDaybooks', mutation);
}
